var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50326_23656)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50326_23656",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H22V22H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50326_23656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.2549C13.0387 13.2549 13.8828 14.0987 13.8828 15.1377C13.8828 16.177 13.0387 17.0205 12 17.0205C10.9613 17.0205 10.1172 16.177 10.1172 15.1377C10.1172 14.0987 10.9613 13.2549 12 13.2549Z",
    stroke: "#5E626E",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72461 13.2549C6.76332 13.2549 7.60742 14.0987 7.60742 15.1377C7.60742 16.177 6.76332 17.0205 5.72461 17.0205C4.6859 17.0205 3.8418 16.177 3.8418 15.1377C3.8418 14.0987 4.6859 13.2549 5.72461 13.2549Z",
    stroke: "#5E626E",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2754 13.2549C19.3141 13.2549 20.1582 14.0987 20.1582 15.1377C20.1582 16.177 19.3141 17.0205 18.2754 17.0205C17.2367 17.0205 16.3926 16.177 16.3926 15.1377C16.3926 14.0987 17.2367 13.2549 18.2754 13.2549Z",
    stroke: "#5E626E",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1393 20.1588V21.4141H8.86328V20.1588C8.86328 18.427 10.2691 17.0208 12.0013 17.0208C13.7335 17.0208 15.1393 18.427 15.1393 20.1588Z",
    stroke: "#5E626E",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86199 20.1588V21.4141H2.58594V20.1588C2.58594 18.427 3.9918 17.0208 5.72398 17.0208C7.45617 17.0208 8.86199 18.427 8.86199 20.1588Z",
    stroke: "#5E626E",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4128 20.1588V21.4141H15.1367V20.1588C15.1367 18.427 16.5425 17.0208 18.2748 17.0208C20.007 17.0208 21.4128 18.427 21.4128 20.1588Z",
    stroke: "#5E626E",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72363 6.35094L6.43598 7.79723L8.0332 8.02914L6.87844 9.15473L7.15145 10.7441L5.72363 9.99387L4.29582 10.7441L4.56883 9.15473L3.41406 8.02914L5.01129 7.79723L5.72363 6.35094Z",
    stroke: "#5E626E",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2764 6.35094L18.9887 7.79723L20.586 8.02914L19.4312 9.15473L19.7042 10.7441L18.2764 9.99387L16.8486 10.7441L17.1216 9.15473L15.9668 8.02914L17.5641 7.79723L18.2764 6.35094Z",
    stroke: "#5E626E",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 2.58594L12.9161 4.44523L14.9684 4.74332L13.4841 6.1909L13.8355 8.23438L11.9998 7.26941L10.1641 8.23438L10.5155 6.1909L9.03125 4.74332L11.0835 4.44523L11.9998 2.58594Z",
    stroke: "#5E626E",
    strokeWidth: 1.17187,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50326_23656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.73c039564b1f41490480ecfab1a73aed.svg";
export { ForwardRef as ReactComponent };